<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span v-if="!data">{{ $t('Add Category') }}</span>
			<span v-else>{{ $t('Edit Category') }}</span>
		</template>
		<template slot="body">
			<form @submit.prevent="save">
				<!-- name -->
				<div class="form-group">
					<label>{{ $t('Name') }}</label>
					<input type="text" name="name" class="form-control" v-model="name" required	@keydown="textKeydown($event)">
				</div>
				<!-- Type -->
				<div v-if="(data && data.id !== 1 && data.id !== 2 && data.id !== 3 && data.id !== 4) || !data" class="form-group select">
					<label>{{ $t('Type') }}</label>
					<div class="mh-40px">
						<multiselect class="select-input" v-model="type" deselect-label="Can't remove this value" track-by="name" label="name"
						placeholder=" " :options="typeOptions" :searchable="false" :allow-empty="false" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
						</span>
						</multiselect>
					</div>
				</div>
				<!-- Description -->
				<div v-if="(data && data.id !== 1 && data.id !== 2 && data.id !== 3 && data.id !== 4) || !data" class="form-group">
					<label>{{ $t('Description') }}</label>
					<input type="text" name="description" class="form-control" v-model="description" required @keydown="textKeydown($event)">
				</div>
				<!-- Submit -->
				<button v-if="!data"
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					{{ $t('Create Category') }}
				</button>
				<button v-else
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					{{ $t('Update Category') }}
				</button>
			</form>
		</template>
	</modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import categoriesApi from '@/api/categories';

export default {
	name: 'CategoryForm',
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		Modal,
		Multiselect,
	},
	data() {
		return {
			name: '',
			type: 'template',
			description: '',
			isSaving: false,
			typeOptions: [
				{ key: 'template', name: 'Template' },
				{ key: 'media', name: 'Media' },
			],
		};
	},
	methods: {
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const template = response.data;
				const message = response.message;
				this.$emit('saved', template);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Template',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Template',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data) {
				categoriesApi.update(this.data.id, params, callback, errorCallback);
			} else {
				categoriesApi.create(params, callback, errorCallback);
			}
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.setData(this.data);
			}
		},
		reset() {
			this.name = '';
			this.type = 'template';
			this.description = '';
		},
		setData(data) {
			this.name = data.name;
			const index = this.typeOptions.findIndex(({ key }) => key === data.type);
			this.type = this.typeOptions[index];
			this.description = data.description;
		},
		textKeydown(e) {
			if (/[^A-Z0-9 ]/gi.test(e.key)) {
				e.preventDefault();
			}
		},
	},
	computed: {
		params() {
			const params = {
				name: this.name,
				type: this.type.key,
				description: this.description,
			};
			return params;
		},
	},
	created() {
		this.initData();
	},
};
</script>
